<template style="">
  <div class="Workload_analysis">

    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="综合查询">
        <el-input v-model="formInline.Name" placeholder="人员账号/姓名"></el-input>
      </el-form-item>

      <el-form-item label="统计时间">
        <el-date-picker value-format="yyyy-MM-dd" v-model="formInline.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="resetfun()">重置</el-button>
      </el-form-item>
    </el-form>

    <div style="width: 100%;height: calc(100% - 115px);background-color: #fff;margin-top: 14px;">
      <el-button type="primary" @click="Income_allocation()" style="margin-top: 14px;margin-left: 1%;">收益配置</el-button>
      <el-table :data="tableData" style="width: 98%;margin-left: 1%;padding-top: 14px;">
        <el-table-column prop="UserID" label="人员账号" ></el-table-column>
        <el-table-column prop="RealName" label="姓名" ></el-table-column>
        <el-table-column prop="ReleaseArticleNumber" label="发布文章数"></el-table-column>
        <el-table-column prop="ReleaseVideoNumber" label="发布视频数"></el-table-column>
        <el-table-column prop="ReleaseMusicNumber" label="发布音频数"></el-table-column>
        <el-table-column prop="ReleasePictureNumber" label="发布图片数"></el-table-column>
        <el-table-column prop="EditArticleNumber" label="编辑文章数"></el-table-column>
        <el-table-column prop="Income" label="所获收益（元）"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="re_look(scope.row)">查看</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange" :current-page.sync="formInline.PageIndex" :page-size="formInline.PageSize" layout="total, prev, pager, next" :total="UndoCount"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formInline: {
        Name: '',
        time: [],
        PageSize: 10,
        PageIndex: 1,
      },
      tableData: [],
      UndoCount: 0,
      dialogVisible: false
    }
  },
  mounted() {
    this.loading();
  },
  methods: {
    resetfun() {
      this.formInline = {
        Name: '',
        time: [],
        PageSize: 10,
        PageIndex: 1,
      }
      this.loading();
    },
    re_look(row) {
      this.$router.push({
        path: '/propagate/Workload_analysis_All',
        query: {UserID: row.UserID},
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    Income_allocation() {
      this.$router.push({
        path: '/propagate/Workload_Income_allocation'})
    },
    handleCurrentChange(val) {
      this.formInline.PageIndex = val;
      this.loading();
    },
    onSubmit() {
      this.loading();
    },
    loading() {
      this.$Http_Post('management/workloadStatistics', { PageIndex: this.formInline.PageIndex, PageSize: this.formInline.PageSize, StartTime: this.formInline.time[0], EndTime: this.formInline.time[1], Name:this.formInline.Name }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.UndoCount = res.Counts
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    }
  },
}
</script>
<style>
.Workload_analysis{width: 100%;height: 100%;}
.Workload_analysis .demo-form-inline{padding: 20px;background-color: #fff;}
.Workload_analysis .allocation li{margin-top: 14px;width: 100%;height: 40px;font-size: 16px;}
.Workload_analysis .allocation li span{line-height: 40px;}
</style>
